import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-[#01193D] px-5 sm:px-8 py-24 lg:py-32" data-testid="final-cta-section">
      {/* Studio ambient glow */}
      <div 
        className="absolute -top-28 left-1/2 -translate-x-1/2 w-[600px] h-[350px] rounded-full opacity-20 blur-3xl pointer-events-none" 
        style={{ background: "radial-gradient(circle, #2563EB 0%, #09B2ED 50%, transparent 80%)" }} 
      />
      <div className="absolute inset-0 dot-grid-light opacity-20 pointer-events-none" />

      <Reveal className="relative max-w-3xl mx-auto text-center">
        <h2 className="font-display font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
          Let's build something <span className="text-gradient-electric">exceptional</span> together
        </h2>
        <p className="text-slate-300 text-base lg:text-lg mt-5 max-w-xl mx-auto">
          Tell us where you want to go. We'll engineer the way there.
        </p>
        <Link
          to="/contact"
          data-testid="home-final-cta-button"
          className="btn-gradient inline-flex items-center gap-2 mt-10 text-white text-sm font-semibold px-8 py-3.5 rounded-full"
        >
          Start Your Project <ArrowRight size={16} />
        </Link>
      </Reveal>
    </section>
  );
}
